import {
    PATH_BOOKING,
    PATH_HOME,
    PATH_MENU_SETTING,
    PATH_QUOTES,
    PATH_MY_ACCOUNT,
    PATH_UPDATE_PASSWORD,
    PATH_FAVORITES,
} from "@routes";

/**
 * Checks if the bottom bar (mobile footer) is visible
 * @param pathname - Current pathname
 * @param width - Current window width
 * @returns true if bottom bar is visible, false otherwise
 */
export const isBottomBarVisible = (pathname: string, width: number): boolean => {
    // Bottom bar is only visible on mobile (width < 767)
    if (width >= 767) {
        return false;
    }

    // Bottom bar is visible on these specific paths
    return (
        pathname === PATH_HOME ||
        pathname === PATH_BOOKING ||
        pathname === PATH_MENU_SETTING ||
        pathname === PATH_QUOTES ||
        pathname === PATH_MY_ACCOUNT ||
        pathname === PATH_UPDATE_PASSWORD ||
        pathname === PATH_FAVORITES
    );
};
